import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cloud.svg
 */
const IconCloud: IconComponent = ({
  size = 24,
  color = '#E3E3E3',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M20.53 20.233H14.91a2.273 2.273 0 00-.666-1.216 2.534 2.534 0 00-1.282-.654V15.43h4.351c1.136 0 2.24-.348 3.143-.991a4.85 4.85 0 001.856-2.57 4.553 4.553 0 00-.186-3.095 4.955 4.955 0 00-2.156-2.357v-.213c-.005-1.379-.592-2.7-1.635-3.675C17.293 1.554 15.88 1.004 14.405 1a5.823 5.823 0 00-2.351.488A5.47 5.47 0 0010.15 2.87a4.215 4.215 0 00-4.025.768 3.713 3.713 0 00-1.312 2.426c-1.129.408-2.07 1.172-2.659 2.16a4.576 4.576 0 00-.567 3.25 4.792 4.792 0 001.784 2.84 5.405 5.405 0 003.313 1.117h5.265v2.933a2.54 2.54 0 00-1.284.654 2.27 2.27 0 00-.664 1.216h-5.62a.523.523 0 00-.358.138.46.46 0 00-.15.335.46.46 0 00.15.334.523.523 0 00.358.14h5.643c.123.516.43.978.872 1.309.441.33.99.511 1.555.511.566 0 1.117-.18 1.558-.511.442-.331.75-.793.872-1.31h5.64c.133 0 .263-.05.358-.139a.457.457 0 00.148-.334.457.457 0 00-.148-.335.528.528 0 00-.359-.138h.008zM2.516 10.58c-.001-.834.284-1.647.812-2.32A4.186 4.186 0 015.45 6.843a.518.518 0 00.254-.173c.063-.08.099-.177.101-.277a2.787 2.787 0 01.91-1.983 3.185 3.185 0 012.129-.833c.436.005.866.094 1.265.26.108.046.23.056.345.03a.546.546 0 00.292-.17 4.543 4.543 0 012.272-1.56 4.858 4.858 0 012.82-.008 4.546 4.546 0 012.283 1.545c.567.728.873 1.606.873 2.507.003.142-.004.284-.025.425a.436.436 0 00.056.279c.05.085.128.153.222.194a4.048 4.048 0 011.67 1.436c.402.614.613 1.322.608 2.042-.002 1.035-.444 2.027-1.227 2.759a4.329 4.329 0 01-2.95 1.143H6.698a4.393 4.393 0 01-1.599-.283 4.163 4.163 0 01-1.356-.839 3.864 3.864 0 01-.908-1.263 3.656 3.656 0 01-.317-1.493z"
      fill="currentColor"
    />
  </svg>
);

export default IconCloud;
